var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkIcon = function SvgLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#344054",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    d: "m11.086 15.378-1.179 1.178a4.167 4.167 0 1 1-5.892-5.893l1.178-1.178M15.8 10.664l1.178-1.179a4.167 4.167 0 1 0-5.892-5.893L9.907 4.771m-2.327 8.22 5.833-5.833"
  })));
};
export default SvgLinkIcon;